import { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import _isEmpty from 'lodash/isEmpty';
import compose from 'recompose/compose';

import { useStore } from 'store';
import { resetGifts } from 'store/actions/gifts/actions';
import { withAgentPage, withLayout } from 'hocs';

// import arrow from 'assets/img/arrow.svg';
import AddGiftTable from 'pages/TableAdmin/MyGiftTable/addGifts';
import ClosedTableMessage from 'components/gifts-table/ClosedTableMessage';


import { SEARS_PRODUCT, TOTAL_GIFT_TABLES } from 'constants/storage64';
import { encodeStorage, decodeStorage } from 'functions/storageBase64';
import { useWindowSize } from 'hooks';
import styles from './styles.module.scss';

/* /Mesa-de-Regalos/agregar-regalos */
function AddGifts() {
  const [tableStatus, setTableStatus] = useState('');
  const [tableOpen, setTableOpen] = useState(false);
  const [giftTable, dispatch] = useStore((state) => state.giftTable.giftTable);
  const [, { isMobile }] = useWindowSize();

  useEffect(() => {
    if (!_isEmpty(giftTable)) {
      setTableStatus(giftTable.estatus || giftTable.status);
      setTableOpen(tableStatus === 'Open');
    }
  }, [giftTable, tableStatus]);

  useEffect(() => {
    if (!_isEmpty(giftTable)) {
      const savedUrl = decodeStorage(SEARS_PRODUCT);
      const total_gift_tables = decodeStorage(TOTAL_GIFT_TABLES);
      const isChangedGiftTable = decodeStorage('isChangedGiftTable');
      if(savedUrl && savedUrl.length && !isChangedGiftTable) {
        if(+total_gift_tables > 1) {
          encodeStorage('isChangedGiftTable', false);
          document.getElementById('GiftsHeader__eventnumber_button').click();
        }
        else
          encodeStorage('isChangedGiftTable', true);
      }
    }
  });

  useEffect(() => () => dispatch(resetGifts()), []);

  return (
    <div className={styles.container}>
      {!isMobile && (
        <div className={`${styles.grayBar} text-lg-center d-flex`}>
          <b>Agregar por categoría</b>
        </div>
      )}
      
      {/* <div className={`${styles.darkBar} text-lg-center d-flex`}>
        <div>
          Agrega productos a tu mesa directamente desde SEARS.COM.MX O TU
          TIENDA FAVORITA
        </div>
        <div>
          <img src={arrow} alt="arrow" className={styles.img} />
        </div>
      </div> */}

      <div className="pb-1" />
      <Container className="mt-4 mt-md-5">
        {tableOpen ? (
          <AddGiftTable addGifts showLoader />
        ) : (
          <div className="mb-5">
            <ClosedTableMessage />
          </div>
        )}
      </Container>
    </div>
  );
}

export default compose(
  withLayout,
  withAgentPage({ fetchTableInfo: true })
)(AddGifts);
